import React from 'react';
import classnames from 'classnames';
import Button from '../../components/form-elements/Button';

function ServiceRequestStepContent({ stepNumber, title, status, children, onGoToStep, onSubmit = () => {} }) {
    const isStepActive = status === 'active';
    const isStepDone = status === 'done';
    const isStepIncomplete = status === 'incomplete';

    return (
        <div className="uk-grid-small uk-grid" data-uk-grid="">
            <div className="uk-width-auto">
                <span className={classnames('uk-badge', { 'uk-background-muted': isStepIncomplete })}>{stepNumber}</span>
            </div>
            <div className="uk-width-expand">
                <div className="uk-grid uk-grid-small" data-uk-grid="">
                    <div className="uk-width-expand">
                        <h4 className={classnames({ 'uk-text-muted': isStepIncomplete })}>{title}</h4>
                    </div>
                    {isStepDone && (
                        <div className="uk-width-auto">
                            <span className="uk-margin-small-right" data-uk-icon="icon: file-edit" />
                            <Button modifier="text" onClick={onGoToStep}>
                                Ändern
                            </Button>
                        </div>
                    )}
                </div>
                {children}
                {isStepActive && (
                    <Button modifier="primary" fullWidth onClick={onSubmit}>
                        weiter
                    </Button>
                )}
            </div>
        </div>
    );
}

export default ServiceRequestStepContent;
